module.exports = "<!--Footer Starts-->\r\n<footer>\r\n    <div class=\"container-fluid\">\r\n        <p style=\"font-size:.9em;\"class=\"copyright text-center\">\r\n                Powered by Cognition Copyright  &copy;  {{currentDate | date: 'yyyy'}} <a id=\"cognitionLink\" href=\"http://www.cognition.world/\">\r\n                    Cognition Services Limited</a>, All rights reserved.          \r\n        </p>\r\n        \r\n    </div>\r\n</footer>\r\n<!--Footer Ends-->"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer/footer.component.html
// module id = ./src/app/shared/footer/footer.component.html
// module chunks = main